import React, { useEffect, useState } from "react";
import { checkiconWhite, otpicon, rightarrowwhite } from "../../../../images";
import "./businessregistrationotp.scss";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import BlinkingDots from "../../../../Animations/BlinkingDots/BlinkingDots";
import FooterV2 from "../../../../components/FooterV2/FooterV2";
import { useLocation, useNavigate } from "react-router";
import config from "../../../../config/config";

import Joi from "joi";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";

import {
  businessFormFiveLTURL,
  dashboardURL,
  registrationBusinessURL
} from "../../../../components/helpers/constant-words";
import { useAuth } from "../../../../context/Auth/AuthState";
import LightThemeBackground from "../../../../Animations/LightThemeBackground/LightThemeBackground";
import useTheme from "../../../../components/useTheme/useTheme";

const BusinessRegistrationOTP = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const [otpVal, setOtpVal] = useState("");
  const [resend, setResend] = useState(false);
  const [timer, setTimer] = useState(30);
  const [otploading, setotpLoading] = useState(false);

  const navigate = useNavigate();
  const auth = useAuth();
  const base_url = config.api_url; //without trailing slash
  const { values } = location.state || {};

  const handleotpChange = (otp) => {
    setOtpVal(otp);
  };

  const handleotpverify = async (e) => {
    const data = await http.post(base_url + "/business/signup/otp-verify", {
      ...values,
      otp: otpVal,
      status: "registered",
    });
    if (!data) {
      setOtpVal("");
    }
    if (data) {
      const token = data.data.token;
      // localStorage.setItem(config.jwt_auth_key, token);
      // setvisibility({
      //   form: false,
      //   otp: false,
      //   thank_you: true,
      // });
      // navigate("/design-enthusiast");
      auth.login(token);
      navigate(businessFormFiveLTURL, { replace: true });
      window.scrollTo(0, 0);
    }
  };

  const handlresendotp = async (e) => {
    setotpLoading(true);
    const { data } = await http.post(base_url + "/business/signup", values);

    if (data) {
      setOtpVal("");
      toast(<Msg />, {
        className: "otp_toast",
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        closeButton: false,
        autoClose: 1500,
      });
      setTimer(30);
    }

    setotpLoading(false);
  };

  const Msg = () => (
    <div className="otp_box">
      <img
        width={39}
        height={39}
        src={checkiconWhite}
        className="otp_resend_icon"
        loading="lazy"
        alt="icon"
      />
      <p className="title">OTP reshared</p>
    </div>
  );
  const resendHandler = () => {
    if (resend === false) {
      setResend(true);
      toast(<Msg />, {
        className: "otp_toast",
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        closeButton: false,
      });
    } else {
      setResend(false);
    }
  };

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer]);

    useEffect(() => {
      if (!values) {
        window.location.href = registrationBusinessURL;
      }
    }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {theme === "dark" ? <BlinkingDots /> : <LightThemeBackground />}
      <section className="business_otp_sec1">
        <div className="my_container">
          <div className="otp_main_box">
            <div className="text_container">
              <p className="head_text">OTP Verification</p>
              <h1 className={`title ${theme === "dark" && "text-white"}`}>
                Verify your OTP sent via SMS
              </h1>
              <div className="icon_notice_wrapper">
                <div className="icon_wrapper">
                  <img
                    width={81}
                    height={81}
                    src={otpicon}
                    alt="icon"
                    className="icon"
                    loading="lazy"
                  />
                </div>
                <p
                  className={`description mb-0 ${
                    theme === "dark" && "text-white"
                  }`}
                >
                  Enter OTP
                </p>
              </div>
            </div>

            <div className="otp_box_wrapper mt-3">
              <OtpInput
                value={otpVal}
                onChange={handleotpChange}
                numInputs={6}
                containerStyle="otp_input_wrapper"
                inputStyle={
                  theme === "light"
                    ? "otp_input"
                    : "otp_input otp_ip--bg text-black"
                }
                isInputNum={true}
                focusStyle={
                  theme === "dark" ? "otp_focused_dark_mode" : "otp_focused"
                }
                shouldAutoFocus
              />
            </div>
            <div className="next_logout">
              <div className="cta_wrapper">
                <button
                  className="next_button"
                  style={{
                    opacity: otpVal.length < 6 ? 0.5 : 1,
                    cursor: otpVal.length < 6 ? "no-drop" : "pointer",
                  }}
                  disabled={otpVal.length >= 6 ? false : true}
                  onClick={handleotpverify}
                >
                  <div className="text">Verify</div>
                  <img
                    src={rightarrowwhite}
                    alt="icon"
                    className="icon"
                    loading="lazy"
                  />
                </button>
                <button
                  className={`back_button ${theme === "dark" && "text-white"}`}
                  onClick={handlresendotp}
                  disabled={timer > 0 || otploading}
                  style={{
                    opacity: timer > 0 || otploading ? 0.75 : 1,
                    cursor: timer > 0 || otploading ? "not-allowed" : "pointer",
                  }}
                >
                  {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
        {theme === "dark" ? (
          <FooterV2 whatsappBotIcon={false} />
        ) : (
          <FooterV2 lightTheme whatsappBotIcon={false} />
        )}
      </section>
    </>
  );
};

export default BusinessRegistrationOTP;
